import React, { useState, useEffect, useMemo, useRef } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import { AgGridReact } from 'ag-grid-react';
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import redirectURL from "../redirectURL";
import { Modal } from "react-responsive-modal";
import 'react-responsive-modal/styles.css';
import { FaInfoCircle } from "react-icons/fa";
import "./datepicker.css"


const WarehouseStockStatus = () => {
    const [loadshow, setLoadshow] = useState("show-n");
    const [overlayBlock, setOverlayBlock] = useState("show-n");
    const [overlyBlock, setOverlyBlock] = useState("show-n");
    const [show, setShow] = useState(false);
    const [basicTitle, setBasicTitle] = useState("");
    const [basicType, setBasicType] = useState("default");
    const [rowData, setRowData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);

    // Filter states
    const [cycleDate, setCycleDate] = useState("");
    const [destination, setDestination] = useState({ label: "ALL", value: "" });
    const [destinationOptions, setDestinationOptions] = useState([{ label: "ALL", value: "" }]);
    const [latestCycleDate, setLatestCycleDate] = useState("");

    // Slider state for Trigger Warehouse Stock
    const [isSliderOpen, setSliderOpen] = useState(false);
    const [sliderType, setSliderType] = useState(null);
    const [sliderCl, setSliderCl] = useState("");
    const [sliderTitle, setSliderTitle] = useState("");
    const [triggerDate, setTriggerDate] = useState("");
    const [isTriggering, setIsTriggering] = useState(false);

    const today = new Date().toLocaleDateString("en-CA", {
        timeZone: "Asia/Kolkata",
    });

    const [currentDate, setCurrentDate] = useState(today);
    const [isTrigger, setIsTrigger] = useState(null);
    const [triggerStatus, setTriggerStatus] = useState(null);
    const [triggerNote, setTriggerNote] = useState(null);
    const [highlightedDates, setHighlightedDates] = useState([]);


    // Old CustomHeader component
//    const CustomHeader = (props) => {
//      const tooltip = props?.column?.getColDef()?.headerTooltip || "";
//      const [showMenu, setShowMenu] = useState(false);
//      const [showTooltip, setShowTooltip] = useState(false);
   
//      const onMenuClick = (event) => {
//        props.showColumnMenu(event.currentTarget);
//      };
   
//      return (
//        <div
//          style={{ display: "flex", alignItems: "center", gap: 6, position: "relative" }}
//          onMouseEnter={() => setShowMenu(true)}
//          onMouseLeave={() => setShowMenu(false)}
//        >
//          {/* Header Name */}
//          <span style={{ cursor: "default" }}>{props.displayName}</span>
   
//          {/* Info Icon with instant tooltip */}
//          <div
//            style={{ position: "relative", display: "inline-block" }}
//            onMouseEnter={() => setShowTooltip(true)}
//            onMouseLeave={() => setShowTooltip(false)}
//          >
//            <FaInfoCircle style={{ fontSize: 18, opacity: 0.7,  }} />
         
//          </div>
   
//          {/* Menu Button (☰) visible only on hover */}
//          {props.enableMenu && (
//            <span
//              onClick={onMenuClick}
//              style={{
//                marginLeft: "5px",
//                cursor: "pointer",
//                fontSize: 14,
//                opacity: showMenu ? 1 : 0,
//                transition: "opacity 0.2s ease",
//              }}
//            >
//              ☰
//            </span>
//          )}
//        </div>
//      );
//    };
    const getHighlightedDates = async () => {  
  try {
    const response = await redirectURL.post("indentation/getWHCurrentStockdates", {});
    if (response.status === 200 && response.data.dates) {
      const dates = response.data.dates.map(dateStr => {
        try {
          return new Date(dateStr);
        } catch (e) {
          return null;
        }
      }).filter(date => date !== null);
      setHighlightedDates(dates);
    }
  } catch (error) {
    console.error("Failed to fetch highlighted dates:", error);
  }
}
    // New CustomHeader component
    const CustomHeader = (props) => {
        const tooltip = props?.column?.getColDef()?.headerTooltip || "";
        const [showMenu, setShowMenu] = useState(false);
        const [showTooltip, setShowTooltip] = useState(false);

        const onMenuClick = (event) => {
            props.showColumnMenu(event.currentTarget);
        };

        // Handle sort icon click
        const onSortRequested = (order, event) => {
            props.setSort(order, event?.shiftKey);
        };

        // Get current sort state
        const getSort = () => {
            return props.column.getSort();
        };

        // Check if sorting is enabled for this column
        const isSortable = props.column.getColDef().sortable;

        return (
            <div
                style={{ display: "flex", alignItems: "center", gap: 6, position: "relative" }}
                onMouseEnter={() => setShowMenu(true)}
                onMouseLeave={() => setShowMenu(false)}
            >
                {/* Header Name - Make it clickable for sorting */}
                <span
                    style={{
                        cursor: isSortable ? "pointer" : "default",
                        userSelect: "none"
                    }}
                    onClick={isSortable ? () => {
                        const currentSort = getSort();
                        let newSort = 'asc';
                        if (currentSort === 'asc') newSort = 'desc';
                        else if (currentSort === 'desc') newSort = null;
                        onSortRequested(newSort, null);
                    } : undefined}
                >
                    {props.displayName}
                </span>

                {/* Sort indicator */}
                {isSortable && (
                    <div style={{ display: "flex", flexDirection: "column", marginRight: 2 }}>
                        <span
                            style={{
                                cursor: "pointer",
                                fontSize: 10,
                                opacity: getSort() === 'asc' ? 1 : 0.3,
                                lineHeight: "8px"
                            }}
                            onClick={() => onSortRequested('asc', null)}
                        >
                            {/* ↑ */}
                        </span>
                        <span
                            style={{
                                cursor: "pointer",
                                fontSize: 10,
                                opacity: getSort() === 'desc' ? 1 : 0.3,
                                lineHeight: "8px"
                            }}
                            onClick={() => onSortRequested('desc', null)}
                        >
                            {/* ↓ */}
                        </span>
                    </div>
                )}

                {/* Info Icon with instant tooltip */}
                <div
                    style={{ position: "relative", display: "inline-block" }}
                    onMouseEnter={() => setShowTooltip(true)}
                    onMouseLeave={() => setShowTooltip(false)}
                >
                    <FaInfoCircle style={{ fontSize: 18, opacity: 0.7 }} />

                    {/* Tooltip */}
                    {showTooltip && tooltip && (
                        <div
                            style={{
                                position: "absolute",
                                top: "100%",
                                left: "50%",
                                transform: "translateX(-50%)",
                                // backgroundColor: "rgba(0, 0, 0, 0.8)",
                                color: "white",
                                padding: "8px 12px",
                                borderRadius: "4px",
                                fontSize: "12px",
                                whiteSpace: "nowrap",
                                zIndex: 1000,
                                marginTop: "5px",
                                // pointerEvents: "none", // Add this line
                            }}
                        >
                            {tooltip}
                        </div>
                    )}
                </div>

                {/* Menu Button (☰) visible only on hover */}
                {props.enableMenu && (
                    <span
                        onClick={onMenuClick}
                        style={{
                            marginLeft: "5px",
                            cursor: "pointer",
                            fontSize: 14,
                            opacity: showMenu ? 1 : 0,
                            transition: "opacity 0.2s ease",
                        }}
                    >
                        ☰
                    </span>
                )}
            </div>
        );
    };

    const gridApi = useRef(null);
    const gridColumnApi = useRef(null);

    const columnWithDefs = [
        {
            headerName: "Destination Store ID",
            field: "destination_store_id",
            tooltipField: "destination_store_id",
            sortable: true,
            resizable: true,
            width: 150,
        },
        {
            headerName: "Destination Store Name",
            field: "destination_store_name",
            tooltipField: "destination_store_name",
            sortable: true,
            resizable: true,
            width: 200,
        },
        {
            headerName: "Destination Type",
            field: "destination_type",
            tooltipField: "destination_type",
            sortable: true,
            resizable: true,
            width: 150,
        },
        {
            headerName: "Source Name",
            field: "plant_name",
            tooltipField: "plant_name",
            sortable: true,
            resizable: true,
            width: 150,
        },
        {
            headerName: "Source ID",
            field: "plant_id",
            tooltipField: "plant_id",
            sortable: true,
            resizable: true,
            width: 120,
        },
        {
            headerName: "SKU Code",
            field: "sku_code",
            tooltipField: "sku_code",
            sortable: true,
            resizable: true,
            width: 120,
        },
        {
            headerName: "SKU Name",
            field: "sku_name",
            tooltipField: "sku_name",
            sortable: true,
            resizable: true,
            width: 220,
        },
        {
            headerName: "SKU Category",
            field: "sku_category",
            tooltipField: "sku_category",
            sortable: true,
            resizable: true,
            width: 160,
        }, {
            headerName: "SKU  Weight (gms)",
            field: "sku_weight_grams",
            sortable: true,
            resizable: true,
            width: 160,
        },
        {
            headerName: "Cycle Date",
            field: "cycle_date",
            tooltipField: "cycle_date",
            sortable: true,
            resizable: true,
            width: 130,
            valueGetter: (params) => {
                if (params.data && params.data.cycle_date) {
                    const date = new Date(params.data.cycle_date);
                    return date.toISOString().split("T")[0]; // formats to YYYY-MM-DD
                }
                return "";
            },
        }
        ,
        {
            headerName: "Transit Days",
            field: "transit_days",
            tooltipField: "transit_days",
            sortable: true,
            resizable: true,
            width: 130,
        },
        {
            headerName: "Packaging Days",
            field: "packaging_time",
            tooltipField: "packaging_time",
            sortable: true,
            resizable: true,
            width: 140,
        },
            {
            headerName: "Qc Hold Days",
            field: "qc_hold_days",
            tooltipField: "qc_hold_days",
            sortable: true,
            resizable: true,
            width: 140,
        },
        {
            headerName: "Replenishment Cycle Days",
            field: "replenishment_cycle_time",
            tooltipField: "replenishment_cycle_time",
            sortable: true,
            resizable: true,
            width: 190,
        },
        {
            headerName: "Production Cycle Days",
            field: "production_cycle_time",
            tooltipField: "production_cycle_time",
            sortable: true,
            resizable: true,
            width: 180,
        },
        {
            headerName: "Protection Days",
            field: "protection_days",
            tooltipField: "protection_days",
            headerTooltip: "Transit Days + Packaging Days + Replenishment Cycle Days + QC Hold Days",
            headerComponent: CustomHeader,
            sortable: true,
            resizable: true,
            width: 150,
        },
           {
            headerName: " Physical Norm Days",
            field: "safety_stock_days",
            tooltipField: "safety_stock_days",
            headerTooltip: "Transit Days + Packaging Days + Replenishment Cycle Days + Production Cycle Days + QC Hold Days",
            headerComponent: CustomHeader,
            sortable: true,
            resizable: true,
            width: 160,
        },
        {
            headerName: "Business Days STD",
            field: "business_days_std",
            tooltipField: "business_days_std",
            sortable: true,
            resizable: true,
            width: 160,
        },
        {
            headerName: "Wholesale Days STD",
            field: "wholesale_days_std",
            tooltipField: "wholesale_days_std",
            sortable: true,
            resizable: true,
            width: 160,
        },
        {
            headerName: "STD",
            field: "std",
            tooltipField: "std",
              headerTooltip: "Business Days STD + Wholesale Days STD",
      headerComponent: CustomHeader,
            sortable: true,
            resizable: true,
            width: 100,
        },
        {
            headerName: "Business Day Run Rate",
            field: "business_day_run_rate",
            tooltipField: "business_day_run_rate",
            sortable: true,
            resizable: true,
            width: 180,
        },
        {
            headerName: "Wholesale Day Run Rate",
            field: "wholesale_day_run_rate",
            tooltipField: "wholesale_day_run_rate",
            sortable: true,
            resizable: true,
            width: 180,
        },
        {
            headerName: "Service Level Factor Z",
            field: "service_level_factor_z",
            tooltipField: "service_level_factor_z",
            sortable: true,
            resizable: true,
            width: 180,
        },
        {
            headerName: "Protection Days Stock",
            field: "protection_days_stock",
            tooltipField: "protection_days_stock",
            headerTooltip: "(Protection Days * Corresponding Run Rates)/2",
            headerComponent: CustomHeader,
            sortable: true,
            resizable: true,
            width: 180,
        },
        {
            headerName: "Standard Deviation Stock",
            field: "standard_deviation_stock",
            hide:true,
            tooltipField: "standard_deviation_stock",
              headerTooltip: "STD * Z* Sqrt(Physical Norm Days)",
      headerComponent: CustomHeader,
            sortable: true,
            resizable: true,
            width: 190,
        },
        {
            headerName: "Physical Norm",
            field: "safety_stock",
            tooltipField: "safety_stock",
              headerTooltip: "STD * Z* Sqrt(Physical Norm Days)",
      headerComponent: CustomHeader,
            sortable: true,
            resizable: true,
            width: 130,
        },
        {
            headerName: "Buffer Stock",
            field: "rop_buffer_stock",
            hide:true,
            tooltipField: "rop_buffer_stock",
              headerTooltip: "(Transit Days  * Corresponding RunRate)/2",
      headerComponent: CustomHeader,
            sortable: true,
            resizable: true,
            width: 150,
        },
        {
            headerName: "Warehouse Norm",
            field: "reorder_point_stock",
            tooltipField: "reorder_point_stock",
             headerTooltip: "Protection Days Stock + Physical Norm",
            headerComponent: CustomHeader,
            sortable: true,
            resizable: true,
            width: 160,
        },
        {
            headerName: "DS Demand",
            field: "darkstores_demand",
            tooltipField: "darkstores_demand",
            //  headerTooltip: "Protection Days Stock + Physical Norm",
            // headerComponent: CustomHeader,
            sortable: true,
            resizable: true,
            width: 160,
        },  {
            headerName: "Gross Weight (gms)",
            field: "gross_weight",
            tooltipField: "gross_weight",
             headerTooltip: "sku Weight * Warehouse Norm",
            headerComponent: CustomHeader,
            sortable: true,
            resizable: true,
            width: 160,
        },


    ];

    const onTriggerSubmit = async (e) => {
    if (!currentDate) {
      setShow(true)
      setBasicTitle("Please select a date")
      setBasicType("info")
      return;
    }
    setLoadshow("show-m");
    setOverlayBlock("show-m");
    setSliderOpen(false)
    setSliderType(null)
    await onTriggerSubmissionFunction()
  };

  // Function To Trigger User Action
  const triggerUserAction = (trigerdata) => {
    redirectURL.post('inventory/triggerUserAction', trigerdata)
  }


//   const onTriggerSubmissionFunction = async () => {
//     try {
//       const response = await redirectURL.post("indentation/onTriggerWarehouseStockStatus", { trigger_date: currentDate })
//       if (response.data.status === "info") {
//         setLoadshow("show-n");
//         setOverlayBlock("show-n");
//         setTriggerNote(response.data.message);
//         setTriggerStatus("info");
//         const userData = {
//             email: localStorage.getItem("email"),
//             user_code: localStorage.getItem("user_code"),
//             action: "Triggered Stock Status - Warehouse Indentation",
//             status: "Info",
//             path: window.location.pathname
//           };
//         triggerUserAction(userData);
//         return
//       } else if (response.data.status === "success") {
//         await getWarehouseStockData()
//         setOverlayBlock("show-n");
//         setLoadshow("show-n");
//         setShow(true)
//         setBasicTitle("Stock Status Triggered Successfully");
//         setBasicType("success");
//         const userData = {
//             email: localStorage.getItem("email"),
//             user_code: localStorage.getItem("user_code"),
//             action: "Triggered Stock Status - Warehouse Indentation",
//             status: "Success",
//             path: window.location.pathname
//           };
//         triggerUserAction(userData);
//       } else {
//         setLoadshow("show-n");
//         setOverlayBlock("show-n");
//         setShow(true);
//         setBasicTitle("Something went wrong. Please try again later.");
//         setBasicType("error");
//         const userData = {
//             email: localStorage.getItem("email"),
//             user_code: localStorage.getItem("user_code"),
//             action: "Triggered Stock Status - Warehouse Indentation",
//             status: "Error",
//             path: window.location.pathname
//           };
//         triggerUserAction(userData);
//       }
//     }
//     catch (error) {
//       console.error("Error triggering inventory:", error);
//       setLoadshow("show-n");
//       setOverlayBlock("show-n");
//       setShow(true);
//       setBasicTitle("Something went wrong. Please try again later.");
//       setBasicType("error");

//     }
//   }
const onTriggerSubmissionFunction = async () => {
  try {
    setLoadshow("show-m");
    setOverlayBlock("show-m");

    const response = await redirectURL.post(
      "indentation/onTriggerWarehouseStockStatus",
      { trigger_date: currentDate }
    );

    const res = response?.data?.pyResponse;

    if (res?.status === "Success") {
      await getWarehouseStockData();

      setLoadshow("show-n");
      setOverlayBlock("show-n");
      setShow(true);
      setBasicTitle(res.message || "Stock Status Triggered Successfully");
      setBasicType("success");

      const userData = {
        email: localStorage.getItem("email"),
        user_code: localStorage.getItem("user_code"),
        action: "Triggered Stock Status - Warehouse Indentation",
        status: res.status,
        path: window.location.pathname
      };
      triggerUserAction(userData);
    } 
    else if (res?.status === "Info") {
      setLoadshow("show-n");
      setOverlayBlock("show-n");

      setTriggerNote(res.message);
      setTriggerStatus("info");

      const userData = {
        email: localStorage.getItem("email"),
        user_code: localStorage.getItem("user_code"),
        action: "Triggered Stock Status - Warehouse Indentation",
        status: res.status,
        path: window.location.pathname
      };
      triggerUserAction(userData);

      return;
    } 
    else {
      setLoadshow("show-n");
      setOverlayBlock("show-n");

      setShow(true);
      setBasicTitle(res?.message || "Something went wrong. Please try again later.");
      setBasicType("error");

      const userData = {
        email: localStorage.getItem("email"),
        user_code: localStorage.getItem("user_code"),
        action: "Triggered Stock Status - Warehouse Indentation",
        status: res?.status || "Error",
        path: window.location.pathname
      };
      triggerUserAction(userData);
    }

  } catch (error) {
    console.error("Error triggering inventory:", error);

    setLoadshow("show-n");
    setOverlayBlock("show-n");

    setShow(true);
    setBasicTitle(
      error?.response?.data?.message || "Something went wrong. Please try again later."
    );
    setBasicType("error");

    const userData = {
      email: localStorage.getItem("email"),
      user_code: localStorage.getItem("user_code"),
      action: "Triggered Stock Status - Warehouse Indentation",
      status: "Failed",
      path: window.location.pathname
    };
    triggerUserAction(userData);
  }
};

  const onClickDeletePopupCancelBtn = () => {
    setOverlayBlock("show-n");
    setOverlyBlock("show-n");
    // setShowDeletePopup(false);
    setSliderOpen(false);
    setSliderType(null);
    
    setTriggerDate("")
    setTriggerStatus(null);
    setTriggerNote("")

  };

const onClickingPopupContinueBtn = async () => {
      await onTriggerWarehouseStock();
      setLoadshow("show-n")
      setOverlayBlock("show-n")
      setTriggerStatus(null);
      setTriggerNote("")
  }



    const resetFilters = () => {
        // Reset to latest cycle date and ALL destinations
        setCycleDate(latestCycleDate);
        setDestination({ label: "ALL", value: "" });

        // Apply the reset filters immediately
        applyResetFilters();
    };

    const applyResetFilters = async () => {
        setLoadshow("show-m");
        setOverlayBlock("show-m");

        try {
            const params = {
                cycle_date: latestCycleDate || "",
                destination_store_id: ""
            };

            const response = await redirectURL.post("indentation/getFilteredWarehouseStockData", params);

            if (response.status === 200) {
                if (response.data.data && response.data.data.length > 0) {
                    setFilteredData(response.data.data);

                    // Also update destination options for the latest date
                    if (latestCycleDate) {
                        await getDestinationOptionsByDate(latestCycleDate);
                    }

                    // Auto-size columns after reset
                    setTimeout(() => {
                        if (gridApi.current) {
                            gridApi.current.sizeColumnsToFit();
                        }
                    }, 100);
                } else {
                    setFilteredData([]);
                    setBasicTitle("No data found for the latest cycle date");
                    setBasicType("info");
                    setShow(true);
                }
            }
        } catch (error) {
            console.error("Error applying reset filters:", error);
            setBasicTitle("Failed to reset filters");
            setBasicType("error");
            setShow(true);
        } finally {
            setLoadshow("show-n");
            setOverlayBlock("show-n");
        }
    };

    const sideBar = useMemo(() => ({
        toolPanels: [
            {
                id: "columns",
                labelDefault: "Columns",
                labelKey: "columns",
                iconKey: "columns",
                toolPanel: "agColumnsToolPanel",
            },
            {
                id: "filters",
                labelDefault: "Filters",
                labelKey: "filters",
                iconKey: "filter",
                toolPanel: "agFiltersToolPanel",
            },
        ]
    }), []);

    const statusPanel = {
        statusPanels: [
            {
                statusPanel: "agTotalAndFilteredRowCountComponent",
                align: "left"
            },
            {
                statusPanel: "agTotalRowCountComponent",
                align: "center"
            },
            { statusPanel: "agFilteredRowCountComponent" },
            { statusPanel: "agSelectedRowCountComponent" },
            { statusPanel: "agAggregationComponent" }
        ]
    };

    const defaultColDef = {
        sortable: true,
        filter: true,
        resizable: true,
        minWidth: 200,
    };

    const onGridReady = (params) => {
        gridApi.current = params.api;
        gridColumnApi.current = params.columnApi;

        setTimeout(() => {
            if (gridApi.current) {
                gridApi.current.sizeColumnsToFit();
            }
        }, 100);
    };

    const onFirstDataRendered = (params) => {
        // Auto-size columns when data is first rendered
        setTimeout(() => {
            if (gridApi.current) {
                gridApi.current.sizeColumnsToFit();
            }
        }, 100);
    };

    const getWarehouseStockData = async () => {
        try {
            setLoadshow("show-m");
            setOverlayBlock("show-m");
            const response = await redirectURL.post("indentation/getWarehouseStockData", {});

            if (response.status === 200) {
                if (response.data.data && response.data.data.length > 0) {
                    const data = response.data.data;
                    setRowData(data);

                    // Get latest cycle date for default selection
                    const latestDate = getLatestCycleDate(data);
                    if (latestDate) {
                        setLatestCycleDate(latestDate);
                        setCycleDate(latestDate);
                        await getDestinationOptionsByDate(latestDate);

                        // Load data for latest cycle date by default
                        await loadDataForLatestDate(latestDate);
                        await getHighlightedDates()
                    }


                    setLoadshow("show-n");
                    setOverlayBlock("show-n");

                } else {
                    setBasicTitle("No warehouse stock data found");
                    setBasicType("info");
                    setShow(true);
                    setLoadshow("show-n");
                    setOverlayBlock("show-n");
                }
            }
        } catch (error) {
            console.error("Error fetching warehouse stock data:", error);
            setBasicTitle("Failed to fetch warehouse stock data");
            setBasicType("error");
            setShow(true);
            setLoadshow("show-n");
            setOverlayBlock("show-n");
        }
    };

    const loadDataForLatestDate = async (date) => {
        try {
            const params = {
                cycle_date: date || "",
                destination_store_id: ""
            };

            const response = await redirectURL.post("indentation/getFilteredWarehouseStockData", params);

            if (response.status === 200) {
                if (response.data.data && response.data.data.length > 0) {
                    setFilteredData(response.data.data);
                } else {
                    setFilteredData([]);
                }
            }
        } catch (error) {
            console.error("Error loading data for latest date:", error);
            setFilteredData([]);
        }
    };

    const getLatestCycleDate = (data) => {
        if (!data || data.length === 0) return "";

        const dates = data
            .map(item => item.cycle_date)
            .filter(date => date)
            .sort((a, b) => new Date(b) - new Date(a));

        return dates.length > 0 ? new Date(dates[0]).toISOString().split('T')[0] : "";
    };

    const getDestinationOptionsByDate = async (date) => {
        try {
            if (!date) {
                setDestinationOptions([{ label: "ALL", value: "" }]);
                return;
            }

            const response = await redirectURL.post("indentation/getDestinationsByCycleDate", {
                cycle_date: date
            });

            if (response.status === 200 && response.data.data) {
                const destinations = response.data.data;
                const options = [
                    { label: "ALL", value: "" },
                    ...destinations.map(dest => ({
                        value: dest.destination_store_id,
                        label: `${dest.destination_store_id} - ${dest.destination_store_name}`
                    }))
                ];
                setDestinationOptions(options);
                setDestination(options[0]);
            }
        } catch (error) {
            console.error("Error fetching destination options:", error);
            setDestinationOptions([{ label: "ALL", value: "" }]);
        }
    };

    const applyFilters = async () => {
        setLoadshow("show-m");
        setOverlayBlock("show-m");

        try {
            const params = {
                cycle_date: cycleDate || "",
                destination_store_id: destination.value || ""
            };

            const response = await redirectURL.post("indentation/getFilteredWarehouseStockData", params);

            if (response.status === 200) {
                if (response.data.data && response.data.data.length > 0) {
                    setFilteredData(response.data.data);

                    // Auto-size columns after filter is applied
                    setTimeout(() => {
                        if (gridApi.current) {
                            gridApi.current.sizeColumnsToFit();
                        }
                    }, 100);
                } else {
                    setFilteredData([]);
                    setBasicTitle("No data found for the selected filters");
                    setBasicType("info");
                    setShow(true);
                }
            }
        } catch (error) {
            console.error("Error applying filters:", error);
            setBasicTitle("Failed to apply filters");
            setBasicType("error");
            setShow(true);
        } finally {
            setLoadshow("show-n");
            setOverlayBlock("show-n");
        }
    };

    const handleCycleDateChange = async (date) => {
        const dateString = date ? new Date(date).toISOString().split('T')[0] : "";
        setCycleDate(dateString);

        if (dateString) {
            await getDestinationOptionsByDate(dateString);
        } else {
            setDestinationOptions([{ label: "ALL", value: "" }]);
            setDestination({ label: "ALL", value: "" });
        }
    };

    const checkTriggerStatusByDate = async (date) => {
        try {

            const triggerResponse = await redirectURL.post("indentation/checkTriggerStatusByDate", { trigger_date: date });
            const status = triggerResponse?.data?.status || "fail";
            if (status === "success") {
                setIsTrigger(status);
            } else {
                setIsTrigger(status);
            }
            return status;
        } catch (e) {
            console.error("Error checking trigger status:", e);
            setLoadshow("show-n");
            setOverlayBlock("show-n");
            setShow(true);
            setBasicTitle("Something went wrong. Please try again later.");
            setBasicType("error");
            return "fail"; // return a default/fallback value
        }
    };

    // Trigger Warehouse Stock Functions
    const openTriggerWarehouseStockSlider = async () => {
        setLoadshow("show-m")
        setOverlayBlock("show-m")
        const status = await checkTriggerStatusByDate(currentDate);
        setLoadshow("show-n")
        setOverlayBlock("show-n")
        setSliderType(1);
        setSliderTitle("Trigger Stock Status");
        setSliderCl("trigger-warehouse-stock-slider");
        setOverlyBlock("show-m");
        setSliderOpen(true);
        setTriggerDate(latestCycleDate || new Date().toISOString().split('T')[0]);
    };

    const hideOverlySlideBlock = () => {
        setOverlyBlock("show-n");
        setLoadshow("show-n");
        setSliderOpen(false);
        setTriggerDate("");
    };

    const onClickingSliderCloseIcon = () => {
        setOverlyBlock("show-n");
        setSliderOpen(false);
        setTriggerDate("");
    };

    // const onTriggerWarehouseStock = async (e) => {
    //     if (!currentDate) {
    //         setShow(true);
    //         setBasicType("info");
    //         setBasicTitle("Please select a date");
    //         return;
    //     }
    //     try {
    //         setIsTriggering(true);
    //         setLoadshow("show-m");
    //         setOverlayBlock("show-m");
    //         const resp = await redirectURL.post("indentation/onTriggerWarehouseStock", {
    //             date: currentDate,
    //         });
    //         await getWarehouseStockData()
    //         setLoadshow("show-n");
    //         setOverlayBlock("show-n");

    //         if (resp.data.status === "success") {
              
    //             setShow(true);
    //             setBasicType("success");
    //             setBasicTitle("Warehouse stock triggered successfully");
    //             setSliderOpen(false);
    //             setOverlyBlock("show-n");
    //             setTriggerDate("");

    //         } else {
          
    //             setShow(true);
    //             setBasicType("error");
    //             setBasicTitle(resp.data.message || "Failed to trigger warehouse stock ");
    //         }
    //     } catch (err) {
    //         setLoadshow("show-n");
    //         setOverlayBlock("show-n");
    //         setShow(true);
    //         setBasicType("error");
    //         setBasicTitle("Failed to trigger warehouse stock ");
    //         console.error("Error triggering warehouse stock:", err);
    //     } finally {
    //         setIsTriggering(false);
    //     }
    // };

const onTriggerWarehouseStock = async (e) => {
    if (!currentDate) {
        setShow(true);
        setBasicType("info");
        setBasicTitle("Please select a date");
        return;
    }

    try {
        setIsTriggering(true);
        setLoadshow("show-m");
        setOverlayBlock("show-m");

        const response = await redirectURL.post("indentation/onTriggerWarehouseStock", {
            date: currentDate,
        });

        const pyResponse = response?.data?.pyResponse;

        if (pyResponse?.status === "Success") {
            setLoadshow("show-n");
            setOverlayBlock("show-n");
            setShow(true);
            setBasicType("success");
            setBasicTitle(pyResponse?.message);
            setSliderOpen(false);
            setOverlyBlock("show-n");
            setTriggerDate("");

            await getWarehouseStockData();

            // User action logging for success
            triggerUserAction({
                email: localStorage.getItem("email"),
                user_code: localStorage.getItem("user_code"),
                action: "Trigger Warehouse Stock",
                status: pyResponse?.data?.status || pyResponse?.status,
                path: window.location.pathname
            });
        } else {
            setLoadshow("show-n");
            setOverlayBlock("show-n");
            setShow(true);
            setBasicType("info");
            setBasicTitle(pyResponse?.data?.message || pyResponse?.message);
            setTriggerDate("");

            triggerUserAction({
                email: localStorage.getItem("email"),
                user_code: localStorage.getItem("user_code"),
                action: "Trigger Warehouse Stock",
                status: pyResponse?.data?.status || pyResponse?.status,
                path: window.location.pathname
            });
        }

    } catch (err) {
        console.error("Error triggering warehouse stock:", err);
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("error");
        setBasicTitle(
            err?.response?.data?.message || 
            err?.message || 
            "Failed to trigger warehouse stock"
        );
    } finally {
        setIsTriggering(false);
    }
};




    useEffect(() => {
        const getData = async () => {
            await getWarehouseStockData();
        };
        getData();
    }, []);

    const closeAlert = () => {
        setShow(false);
        setSliderOpen(false);
        setTriggerStatus(null)
        setOverlyBlock("show-n");
        setLoadshow("show-n");
        setOverlayBlock("show-n");
    };


    // const onChangeTriggerDate = (date) => {
    //     const newDate = date.toLocaleDateString("en-CA", { timeZone: "Asia/Kolkata" });
    //     // console.log({ newDate })
    //     const status = checkTriggerStatusByDate(newDate);
    //     setIsTrigger(status)
    //     setCurrentDate(newDate)
    // }
    const onChangeTriggerDate = async (date) => {
        if (!date) return;

        const newDate = date.toLocaleDateString("en-CA", { timeZone: "Asia/Kolkata" });
        setCurrentDate(newDate);
        setTriggerDate(newDate);

        const status = await checkTriggerStatusByDate(newDate);
        setIsTrigger(status);
    };


    return (
        <>
            <div className="container-fluid mt-3">
                <div style={{ zIndex: "9999999" }}>
                    <SweetAlert
                        show={show}
                        type={basicType}
                        title={basicTitle}
                        onConfirm={closeAlert}
                        style={{ fontSize: "9px" }}
                    >
                    </SweetAlert>
                </div>

                <div className="row" style={{ fontSize: "0.9rem", fontFamily: "Arial, sans-serif" }}>
                    <form className="col-sm-12 p-0 mb-4" style={{ display: "flex", alignItems: "center" }}>
                        <div className="col-sm-8 row">
                            {/* Cycle Date Filter */}
                            <div className="col-sm-3 mb-1" style={{ display: "flex", flexDirection: "column" }}>
                                <label style={{ fontSize: "13px", fontWeight: "400" }}>
                                    Cycle Date:
                                </label>
                                <DatePicker
                                    selected={cycleDate ? new Date(cycleDate) : null}
                                    onChange={handleCycleDateChange}
                                    dateFormat="yyyy-MM-dd"
                                    className="form-control"
                                    placeholderText="Select Cycle Date"
                                    highlightDates={highlightedDates}

                                />
                            </div>

                            {/* Destination Store Filter */}
                            <div className="col-sm-3 mb-1" style={{ display: 'flex', flexDirection: 'column' }}>
                                <label htmlFor="destination" style={{ fontSize: '13px', fontWeight: '400' }}>
                                    Destination Store:
                                </label>
                                <Select
                                    id="destination"
                                    value={destination}
                                    onChange={(selectedOption) => setDestination(selectedOption)}
                                    options={destinationOptions}
                                    styles={selectStyles}
                                    isDisabled={!cycleDate}
                                />
                            </div>

                            {/* Filter Buttons */}
                            <div className="ml-4 mt-4" style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "0px 10px" }}>
                                <button
                                    type="button"
                                    onClick={(e) => { e.preventDefault(); applyFilters(); }}
                                    style={{
                                        backgroundColor: "#93385D",
                                        color: "#fff",
                                        borderRadius: "5px",
                                        padding: "8px 20px",
                                        border: "none",
                                        cursor: "pointer"
                                    }}
                                >
                                    Apply
                                </button>
                                <button
                                    onClick={(e) => { e.preventDefault(); resetFilters(); }}
                                    type="button"
                                    style={{
                                        backgroundColor: "#fff",
                                        color: "#000",
                                        borderRadius: "5px",
                                        padding: "8px 20px",
                                        border: "1px solid #d9d9d9",
                                        cursor: "pointer"
                                    }}
                                >
                                    Reset
                                </button>
                            </div>
                        </div>

                        {/* Trigger Button */}
                        <div className="col-sm-4 mt-4" style={{ display: "flex", justifyContent: "flex-end" }}>
                            <button
                                type="button"
                                onClick={openTriggerWarehouseStockSlider}
                                style={{
                                    backgroundColor: "#93385D",
                                    color: "#fff",
                                    borderRadius: "5px",
                                    height: "36px",
                                    padding: "0 20px",
                                    border: "none",
                                    cursor: "pointer",
                                    display: "inline-flex",
                                    alignItems: "center"
                                }}
                            >
                                Trigger Stock Status                            </button>
                        </div>
                    </form>

                    {/* Data Grid */}
                    <div className="col-sm-12 p-0 pl-2 mt-6">
                        <div
                            className="ag-theme-alpine"
                            style={{
                                height: 'calc(100vh - 250px)',
                                width: "100%",
                                minHeight: '400px'
                            }}
                        >
                            <AgGridReact
                                rowData={filteredData}
                                columnDefs={columnWithDefs}
                                defaultColDef={defaultColDef}
                                domLayout="normal"
                                onGridReady={onGridReady}
                                // onFirstDataRendered={onFirstDataRendered}
                                // suppressHorizontalScroll={false}
                                sideBar={sideBar}
                                statusBar={statusPanel}
                                // pagination={true}
                                // paginationPageSize={20}
                                enableRangeSelection={true}
                                suppressColumnVirtualisation={true}
                                ensureDomOrder={true}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* Slider for Trigger Warehouse Stock */}
            <div
                className={`stock-status-slider ${isSliderOpen ? "open" : ""} ${sliderCl}`}
                style={{ width: "25%" }}
            >
                <div className="slider-header-container d-flex justify-content-between">
                    <p className="m-0p">{sliderTitle}</p>
                    <p
                        className="m-0p"
                        style={{ cursor: "pointer" }}
                        onClick={onClickingSliderCloseIcon}
                    >
                        X&nbsp;&nbsp;&nbsp;
                    </p>
                </div>
                {sliderType === 1 && (
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            height: "100%",
                            overflowY: "auto",
                            padding: 5,
                        }}
                    >
                        <form
                            style={{ flexGrow: 1, overflowY: "auto", padding: "10px" }}
                            onSubmit={(e) => {
                            e.preventDefault();
                            onTriggerSubmit();
                            }}
                            
                        >

                            <div className="form-group mb-3">
                                <label
                                    htmlFor="trigger-date"
                                    className="form-label"
                                    style={{
                                        fontWeight: "500",
                                        fontSize: "0.9rem",
                                        color: "#444",
                                        marginBottom: "6px",
                                        display: "block",
                                    }}
                                >
                                    Date <span style={{ color: "red" }}>*</span>
                                </label>
                                <DatePicker
                                    inputId="trigger-date"
                                    value={currentDate}
                                    onChange={onChangeTriggerDate}
                                    placeholder="Select Date"
                                    className="form-control"
                                    isClearable
                                    required
                                    maxDate={new Date()}
                                    style={{
                                        width: "100%",
                                        fontSize: "0.9rem",
                                        padding: "8px 10px",
                                        borderRadius: "5px",
                                    }}
                                />
                            </div>
                            <div className="text-end mt-4">
                                <button
                                    type="submit"
                                    className="btn px-4"
                                    style={{
                                        fontSize: "0.9rem",
                                        borderRadius: "5px",
                                        background: "#93385D",
                                        color: "#fff",
                                        fontWeight: 500,
                                        // cursor: isTrigger === "success" ? "pointer" : "not-allowed",
                                        // opacity: isTrigger === "success" ? 1 : 0.6, // visual feedback when disabled
                                    }}
                                    // disabled={isTrigger !== "success"}
                                >
                                    Trigger Stock Status
                                </button>
                            </div>
                        </form>
                    </div>
                )}
                
                {triggerStatus === "info" && (
                    <div
                    className="d-flex justify-content-center align-items-center"
                    style={{
                        position: "fixed",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)", // <-- centers the element
                        zIndex: 1003,
                        backgroundColor: "rgba(255, 255, 255, 0.95)",
                        padding: "20px",
                        borderRadius: "10px",
                        boxShadow: "0 4px 15px rgba(0,0,0,0.2)", // optional: nice shadow
                    }}
                    >
                    <div className="inventory-delete-popup" style={{ minWidth: "300px" }}>
                        <p
                        style={{
                            color: "grey",
                            fontSize: "18px",
                            textAlign: "center",
                            fontWeight: "bold",
                            marginBottom: "20px",
                        }}
                        >
                        {triggerNote}
                        </p>
                        <div className="d-flex justify-content-center gap-2">
                        <button
                            className="btn btn-secondary"
                            onClick={onClickingPopupContinueBtn}
                        >
                            Yes
                        </button>
                        <button
                            className="btn btn-danger"
                            onClick={onClickDeletePopupCancelBtn}
                        >
                            No
                        </button>
                        </div>
                    </div>
                    </div>
                )}
            </div>

            <div className={`loader ${loadshow}`} style={{ zIndex: "1002" }}></div>
            <div className={`overlay-block ${overlayBlock}`}></div>
            <div
                className={"overly-block " + overlyBlock}
                onClick={hideOverlySlideBlock}
            ></div>
        </>
    );
};

// Styles
const selectStyles = {
    control: (base) => ({
        ...base,
        padding: '1px',
        borderRadius: '5px',
        border: '1px solid #d9d9d9',
        minHeight: '38px'
    }),
    singleValue: (base) => ({
        ...base,
        fontWeight: 'normal',
        color: '#333',
        fontSize: "12px"
    }),
    option: (base, state) => ({
        ...base,
        fontSize: "13px",
        fontWeight: state.isSelected ? 'normal' : 'normal',
    })
};

export default WarehouseStockStatus;